import { render, staticRenderFns } from "./BlogBanner.vue?vue&type=template&id=1afcb2a6&scoped=true"
import script from "./BlogBanner.vue?vue&type=script&lang=js"
export * from "./BlogBanner.vue?vue&type=script&lang=js"
import style0 from "./BlogBanner.vue?vue&type=style&index=0&id=1afcb2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afcb2a6",
  null
  
)

export default component.exports